import type { IconProps } from '../types/IconProps.ts';
export const SquareArrowOutUpLeft: IconProps = {
    name: 'SquareArrowOutUpLeft',
    children: [
        `<path d="M3 9V3.5c0-.28.22-.5.5-.5H9M4 4l8 8M3 13v7.5c0 .28.22.5.5.5h17a.5.5 0 0 0 .5-.5v-17a.5.5 0 0 0-.5-.5H13" />`,
    ]
};